<template>
  <div>
    <div class='ctitle'>
    <h2>待审核题目</h2>
    </div>
    <prepare-problem-table :tableData="dshProblemList" ></prepare-problem-table>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import prepareProblemTable from '@/components/prepareProblemTable/prepareProblemTable'

  export default {
    data () {
      return {

      }
    },
    computed: {
      ...mapGetters([
        'dshProblemList'
      ])
    },
    created () {
      this.$store.dispatch('actions_getDshProblemList')
    },
    components: {
      prepareProblemTable
    },
    methods: {

    }
  }
</script>

<style  scoped>
  .ctitle{
    height: 56px;
    width: 100%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// prepareProblemList.vue?1233780b